<div class="help-page-parent-container ">
    <div class="showLink">
        <!-- <h4><a href="https://www.reliancestandard.com/Matrix-eServices-Reporting-Tool/2641/" target="_blank">Click
                here</a>
            to learn Matrix eServices Reporting Tool.
        </h4> -->
        <!-- <h4><span (click)="openModal()"><a>Click here</a></span>
            to play user guide.
        </h4> -->
    </div>
    <p-dialog header="Guided Tours" [(visible)]="showModal" [modal]="true" [style]="{ 'width': '50%' }">
        <ng-template pTemplate="content">
            <div class="modal-body" >
                <div class="icon-container" *ngFor="let guide of guides">
                    <div class="icon" (click)="onIconClick(guide)">
                        <i [ngClass]="guide.class"></i>
                        <span class="icon-text">{{guide.displayName}}</span>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-dialog>

</div>